import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { NavLink, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";

const AdvancePaymentRequest = () => {
  const employeeId = sessionStorage.getItem("employeeId");
  const { token } = useContext(AuthContext);
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [plan, setPlan] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [generalMaster, setGeneralMaster] = useState([]);


  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    if (!amount || !reason || !plan) {
      setError("All fields except attachment are mandatory.");
      return;
    }

    if (parseFloat(amount) > 1000000) {
      setError("Amount cannot be greater than 10 Lakhs.");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("EmployeeId", employeeId ? parseInt(employeeId) : 0);
      formData.append("AmountRequested", amount ? parseFloat(amount) : 0);
      formData.append("Reason", reason);
      formData.append("RepaymentPlan", plan ? parseInt(plan) : 0);
      if (attachment) {
        formData.append("Attachment", attachment);
      }

      const response = await axios.post(
        `${API_BASE_URL}/api/AdvancePayment/request`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status == 400) {
        setNotification({
          type: "error",
          message: response.data.message,
        });
        return
      }

      navigate("/app/advancepaymentrequestlist");
    } catch (err) {
      console.error("Request error:", err.response?.data || err.message);
      setError(
        err.response?.data?.message || "Failed to submit request. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    const fetchgeneralMaster = async () => {
      const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {

      });
      if (res.ok) {
        const data = await res.json();
        setGeneralMaster(data);
      }
    };
    fetchgeneralMaster();

  }, [token]);
  const handleCloseNotification = () => {
    setNotification(null);
  };

  return (
    <div className="flex flex-1 justify-center py-5">
      <div className="layout-content-container flex flex-col py-5 max-w-[1400px] flex-1">
        {notification && (
          <div
            className={`mb-4 px-4 py-3 rounded flex justify-between items-start ${notification.type === "error"
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
              }`}
          >
            <span>{notification.message}</span>
            <button
              onClick={handleCloseNotification}
              className="ml-4 font-bold text-lg leading-none"
            >
              ×
            </button>
          </div>
        )}

        <div className="flex flex-wrap justify-between gap-3 p-4">
          <p className="text-[#121517] text-[32px] font-bold">
            Request Advance Payment
          </p>
        </div>

        {error && <p className="text-red-500 px-4">{error}</p>}
        {success && <p className="text-green-600 px-4">{success}</p>}

        {/* Two-column layout for Amount Requested & Repayment Plan */}
        <div className="grid grid-cols-2 gap-6 px-4 py-3">
          {/* Amount Requested */}
          <label className="flex flex-col flex-1">
            <span className="text-[#121517] text-base font-medium pb-2">Amount Requested</span>
            <input
              type="number"
              placeholder="Enter amount"
              className="form-input rounded-xl border h-14 p-[15px] flex-1"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
            />
          </label>

          {/* Repayment Plan */}
          <label className="flex flex-col flex-1">
            <span className="text-[#121517] text-base font-medium pb-2">Repayment Plan</span>
            <select
              className="form-input rounded-xl border h-14 p-[15px] flex-1"
              value={plan}
              onChange={(e) => setPlan(e.target.value)}
              required
            >
              <option value="">Select repayment plan</option>
              {generalMaster
                .filter((x) => x.mainId == 85)
                .map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.title}
                  </option>
                ))}
            </select>
          </label>
        </div>

        {/* Two-column layout for Supporting Document */}
        <div className="grid grid-cols-2 gap-6 px-4 py-3">
          <label className="flex flex-col flex-1">
            <span className="text-[#121517] text-base font-medium pb-2">Supporting Document (Optional)</span>
            <input
              type="file"
              className="form-input rounded-xl border h-14 p-[15px] flex-1"
              onChange={(e) => setAttachment(e.target.files[0])}
            />
          </label>
        </div>

        {/* Reason for Request below Supporting Document */}
        <div className="px-4 py-3">
          <label className="flex flex-col flex-1">
            <span className="text-[#121517] text-base font-medium pb-2">
              Reason for Request
            </span>
            <textarea
              placeholder="Describe the reason for the advance"
              className="form-input rounded-xl border min-h-36 p-[15px]"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
            ></textarea>
          </label>
        </div>

        {/* Submit */}
        <div className="flex px-4 py-3 gap-2 justify-end">
          <button
            onClick={() => navigate("/app/advancepaymentrequestlist")}
            className="cancel-btn"
          >
            Close
          </button>
          <button onClick={handleSubmit} className="btn-black">
            Submit Request
          </button>
        </div>
      </div>
    </div>

  );
};

export default AdvancePaymentRequest;